import { CircularProgress, TextField } from "@material-ui/core";
import React from "react";
import { useEffect, useState } from "react";
import {
  getPossibleSchoolManagers,
  switchSchoolManager,
} from "@shared/services/schools";
import { showMessage } from "@shared/store/actions/message.actions";
import { closeDialog } from "@shared/store/actions/dialog.actions";
import CustomButton from "../CustomButton/CustomButton";
import { useDispatch } from "react-redux";

const ChangeSchoolManagerModal = ({ school_id, onSaved }) => {
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState([]);
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    setLoading(true);
    getPossibleSchoolManagers(school_id).then((response) => {
      setRows(response.data);
      setSelected(response.data.filter((row) => row.primary)[0]?.id ?? null);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    const filteredRows = rows.filter((row) => {
      return row.name.toLowerCase().includes(search.toLowerCase());
    });
    setAdmins(filteredRows);
  }, [rows, search]);

  const onSubmit = () => {
    if (!selected || loading) return;
    setLoading(true);
    switchSchoolManager(school_id, selected)
      .then((response) => {
        setLoading(false);
        if (onSaved) {
          onSaved(selected);
        }
        dispatch(
          showMessage({
            message:
              response.data.message || "School manager switched successfully",
            variant: "success",
          })
        );
        dispatch(closeDialog());
      })
      .catch((error) => {
        setLoading(false);
        dispatch(
          showMessage({
            message:
              error?.response?.data?.message ||
              "Failed to switch school manager",
            variant: "error",
          })
        );
      });
  };

  const displayRole = (role) => {
    if (!role) return "";
    if (role === "school_admin") return "School Admin";
    if (role === "company_owner") return "Company Owner";
    return role;
  };

  return (
    <div className="bg-white px-32 min-h-[450px] max-h-[480px] pt-[10px] min-[400px]:min-w-[370px] min-[500px]:min-w-[440px]">
      <div className="flex justify-between py-[10px] px-0 content-center items-center mx-auto font-bold w-[90%]">
        <div>
          <h1 className="text-[20px] font-bold my-[13.4px]">
            Switch School Manager
          </h1>
        </div>

        <div>
          <i
            className="fas text-[20px]"
            onClick={() => dispatch(closeDialog())}
            style={{ cursor: "pointer" }}
          />
        </div>
      </div>
      <div>
        <TextField
          className="w-full"
          inputProps={{ type: "search" }}
          label="Filter by name"
          onChange={(e) => setSearch(e.target.value)}
          value={search}
        />
      </div>

      <div>
        {loading ? (
          <div className="w-1/12 mx-auto mt-16">
            <CircularProgress size={35} />
          </div>
        ) : (
          <>
            {admins?.map((admin, i, arr) => {
              return (
                <div
                  className={admin.id === selected ? "bg-grey-150" : "bg-white"}
                  key={admin.id}
                  onClick={() => setSelected(admin.id)}
                  style={{
                    cursor: "pointer",
                  }}
                >
                  <div className="p-16 flex justify-between">
                    <div className="w-[310px]">
                      <h5 className="text-[14px]">{admin.name}</h5>
                      <div className="text-[10px]">{admin.email}</div>
                      <div className="text-[10px]">
                        {displayRole(admin.role)}
                      </div>
                    </div>
                    <div
                      className={`rounded-full flex justify-center items-center p-4 border-[1px] border-pd-blue-light w-[24px] h-[24px] ${admin.id === selected ? "text-pd-blue-light" : "text-white"}`}
                    >
                      <i className="fas fa-check" />
                    </div>
                  </div>
                  {i !== arr.length - 1 ? (
                    <hr style={{ borderColor: "lightgray" }} />
                  ) : null}
                </div>
              );
            })}
          </>
        )}
      </div>

      <div className="w-full flex justify-center">
        {loading ? (
          <div className="w-1/12 mx-auto mt-24">
            <CircularProgress size={35} />
          </div>
        ) : (
          <div className="mt-[25px]">
            <CustomButton
              disabled={!selected}
              height={38}
              onClick={onSubmit}
              type="button"
              width={156}
            >
              Switch Manager
            </CustomButton>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChangeSchoolManagerModal;
